import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

/**
 * Hover hint in the app's tooltip style (navy, white text — same as TopAccountsCard's rationale).
 * `content` may be a node or a string; nothing renders around `children` when it is empty.
 * Layout already mounts a TooltipProvider.
 */
export default function Hint({ content, children, side = 'top', onOpenChange }) {
  if (!content && !onOpenChange) return children;
  return (
    <Tooltip delayDuration={150} onOpenChange={onOpenChange}>
      <TooltipTrigger asChild>
        <span className="inline-flex cursor-help">{children}</span>
      </TooltipTrigger>
      <TooltipContent side={side} className="max-w-xs border-0 bg-[#0A1A2F] p-3 text-xs leading-relaxed text-white shadow-lg">
        {content}
      </TooltipContent>
    </Tooltip>
  );
}
